import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchDeliveryNoteDetail = createAction(ACTION.FETCH_DELIVERY_NOTE_DETAIL.REQUEST);
export const clearState = createAction(ACTION.CLEAR_STATE_FETCH_DELIVERY_NOTE_DETAIL);
export const updateDelivery = createAction(ACTION.UPDATE_DELIVERY_NOTE_DETAIL.REQUEST, (id,payload, cb) => ({id, ...payload, cb}));

export const removePackageFromDeliveryNote = createAction(ACTION.REMOVE_PACKAGE_FROM_DELIVERY_NOTE.REQUEST, (deliveryNoteId, packageIds) => ({deliveryNoteId, packageIds}));
export const removeBagFromDeliveryNote = createAction(ACTION.REMOVE_BAG_FROM_DELIVERY_NOTE.REQUEST, (deliveryNoteId, bagIds) => ({deliveryNoteId, bagIds}));
